<script>
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { mapActions, mapState } from 'vuex';
import columns from '@/pages/blogs/categories/columns';
import {
  DownOutlined,
  UpOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons-vue';
import BlogCategoryEditor from '@/components/modals/Blog-category-editor.vue';
import { removeObserveTarget } from 'ant-design-vue/es/affix/utils';

export default {
  components: {
    BlogCategoryEditor,
    UpOutlined,
    DownOutlined,
    PageHeader,
    EditOutlined,
    DeleteOutlined,
  },
  data() {
    return {
      title: 'Categories',
      columns: columns(),
      isNewCategory: true,
      selectedCategory: null,
      isShowEditorPopUp: false,
    };
  },
  methods: {
    removeObserveTarget,
    ...mapActions({
      getCategoriesAction: 'blogs/getCategories',
      editCategoryOrderIndexAction: 'blogs/editCategoryOrderIndex',
      onDeleteCategoryAction: 'blogs/onDeleteCategory',
    }),
    openCategoryEditor(category) {
      if (category) {
        this.selectedCategory = category;
        this.isNewCategory = false;
      } else {
        this.isNewCategory = true;
      }
      this.isShowEditorPopUp = true;
    },
    onDeleteCategory(id) {
      this.removeObserveTarget();
      this.onDeleteCategoryAction(id);
    },
  },
  mounted() {
    this.getCategoriesAction();
  },
  computed: {
    ...mapState({
      categoriesList: (state) => state.blogs.categoriesList,
      isCategoriesLoaded: (state) => state.blogs.isCategoriesLoaded,
    }),
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <div  class="create-button">
    <a-button
      type="primary"
      html-type="button"
      @click="openCategoryEditor()"
    >
      Add new category
    </a-button>
  </div>
  <div>
    <a-table
      :columns="columns"
      :data-source="categoriesList"
      :pagination="false"
      :loading="!isCategoriesLoaded"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.dataIndex === 'imageUrl'">
          <div>
            <a-image
              :height="150"
              :src="record.imageUrl"
            />
          </div>
        </template>
        <template v-if="column.dataIndex === 'index'">
          <div class="actions">
            <a-button
              v-if="index !== 0"
              type="primary"
              html-type="button"
              @click="editCategoryOrderIndexAction([
                { id: record.id, index: categoriesList[index - 1].index },
                { id: categoriesList[index - 1].id, index: record.index }
              ])"
            >
              <template #icon>
                <UpOutlined />
              </template>
            </a-button>
            <a-button
              v-if="index !== categoriesList.length - 1"
              type="primary"
              html-type="button"
              @click="editCategoryOrderIndexAction([
                { id: record.id, index: categoriesList[index + 1].index },
                { id: categoriesList[index + 1].id, index: record.index }
              ])"
            >
              <template #icon>
                <DownOutlined />
              </template>
            </a-button>
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'actions'">
          <div class="actions">
            <a-button
              class="action-button"
              type="primary"
              html-type="button"
              @click="openCategoryEditor(record)"
            >
              <EditOutlined /> Edit
            </a-button>
            <a-popconfirm title="Sure to delete?" @confirm="onDeleteCategory(record.id)">
              <a-button
                type="primary"
                html-type="button"
                danger
                class="action-button"
              >
                <DeleteOutlined /> Delete
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </template>
    </a-table>
    <div v-if="isShowEditorPopUp">
      <BlogCategoryEditor
        v-model:show="isShowEditorPopUp"
        v-model:clearCategory="selectedCategory"
        :isNewCategory="isNewCategory"
        :category-object="selectedCategory"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .create-button {
    display: flex;
    justify-content: flex-end;
    padding: 10px 20px;
  }
  .order-buttons {
    display: flex;
    flex-direction: column;
  }
  .actions {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .action-button {
    width: 100px;
  }
</style>
